import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import "./Stepper.css";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSearch, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FaEye } from "react-icons/fa";
import AddEmployeeForms from "./addEmployeeForms";

function AddCertificateAndForms() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [savedDetailsList, setSavedDetailsList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const token = JSON.parse(localStorage.getItem("data")).token;
  const companycode = JSON.parse(localStorage.getItem("data")).orgcode;

  const [employeeCertificates, setEmployeeCertificates] = useState({
    companyCode: companycode,
    employeeId: "",
    file: null,
    fileName: "",
    fileSize: "",
    fileContentType: "",
  });

  useEffect(() => {
    getEmployees();
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };


  const getEmployees = async () => {
    try {
      const response = await axios.get(
        `/api/employeedetails/getByCompanycode/${companycode}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setEmployees(response.data);
    } catch (error) {
      handleError(error);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setEmployeeCertificates((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const convertFileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Converts to base64
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  
  const prepareRequestBody = async () => {
    const promises = savedDetailsList.map(async (item) => ({
      companycode: employeeCertificates.companyCode,
      employeeId: employeeCertificates.employeeId,
      file: await convertFileToBase64(item.blob),
      fileName: item.name,
      fileContentType: item.blob.type,
      fileSize: item.blob.size,
    }));
  
    return await Promise.all(promises);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (savedDetailsList.length === 0) {
      toast.error("Please add at least one Certificate before submitting.");
      return;
    }

    setLoading(true);

    const requestBody = await prepareRequestBody();

    try {
      const response = await axios.post(
        "/api/employee-certificates/create",
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Certificates Submitted Successfully");
        navigate(`/users/certificateAndForms`);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else {
        toast.error(error.response.data?.message || "An error occurred.");
      }
    } else {
      toast.error(error.message || "An error occurred.");
    }
  }

  const handleAddUser = () => {
    if (!employeeCertificates.employeeId) {
      toast.error("Please select an employee before adding a certificate.");
      return;
    }
    setIsAddUserModalOpen(true);
  };

  const handleCloseAddUserModal = () => setIsAddUserModalOpen(false);

  const handleSaveDetails = (data) => {
    const blobUrl = URL.createObjectURL(data.blob);
    const newEntry = {
      id: Date.now(),
      name: data.name,
      url: blobUrl,
      blob: data.blob,
    };
    setSavedDetailsList((prevList) => [...prevList, newEntry]);
  };

  const handleRemoveUser = (index) => {
    setSavedDetailsList((prevList) => prevList.filter((_, i) => i !== index));
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div>
      <AdminDashboard />
      {loading && <div className="loading"></div>}
      <div className="col-10 mx-xl-auto ps-xl-10 mt-10">
        <div className="card card-raised">
          <div className="card-body">
            <div className="card-title form-group d-flex align-items-center justify-content-between">
              Add Certificates
            </div>
            <br />
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <label>
                    Company <span style={{ color: "maroon" }}>(Required)</span>
                  </label>
                  <input
                    className="form-control"
                    id="companyCode"
                    value={companycode}
                    readOnly
                    required
                  />
                </div>

                <div className="position-relative w-25">
                        <input
                          type="text"
                          placeholder="Search by name or Employee ID"
                          value={searchTerm}
                          onChange={handleSearchChange}
                          className="form-control"
                          style={{ paddingLeft: "30px" }} // Ensure there's space for the icon inside the input
                        />
                        <span className="position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}>
                          <FontAwesomeIcon icon={faSearch} />
                        </span>
                        </div>

                {/* <div className="col-md-6 mb-2">
                  <label>
                    Employee <span style={{ color: "maroon" }}>(Required)</span>
                  </label>
                  <select
                    className="form-select"
                    id="employeeId"
                    value={employeeCertificates.employeeId}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Employee</option>
                    {employees.map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        {emp.name} {emp.lastname} ({emp.email})
                      </option>
                    ))}
                  </select>
                </div> */}
              </div>

              <div className="d-flex align-items-center justify-content-between mt-4">
                <h5>Certificates:</h5>
                <Button variant="success" onClick={handleAddUser}>
                  <FontAwesomeIcon icon={faPlus} className="me-1" />Add
                </Button>
              </div>

              <div>
                {savedDetailsList.map((entry, index) => (
                  <div key={entry.id} className="mb-3 d-flex align-items-center">
                    <span className="me-2">{index + 1}.</span>
                    <span className="me-3">{entry.name}</span>
                    <Button
                      variant="link"
                      onClick={() => window.open(entry.url, "_blank")}
                      title="View Certificate"
                    >
                      <FaEye />
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleRemoveUser(index)}
                      title="Delete Certificate"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </div>
                ))}
              </div>

              <br />
              <div className="card-title form-group d-flex align-items-center justify-content-between">
                <Button type="button" variant="secondary" onClick={handleBack}>
                  Back
                </Button>
                <Button type="submit" variant="primary" disabled={loading}>
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </div>
        {isAddUserModalOpen && (
          <AddEmployeeForms
            isOpen={isAddUserModalOpen}
            onRequestClose={handleCloseAddUserModal}
            onSave={handleSaveDetails}
          />
        )}
      </div>
    </div>
  );
}

export default AddCertificateAndForms;
